module.exports = __webpack_public_path__ + "static/media/list.0fcfe607.svg";